import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './index.css'
import { router } from './router';
import { useAuthStore } from './features/sso-auth/store/authStore';

if (typeof window !== 'undefined') { // Ensure this runs only in the browser
  const accessToken = localStorage.getItem('access_token');
  if (accessToken) {
    useAuthStore.getState().checkSession().catch(error => {
      console.error("Failed to perform initial session check:", error);
      // Optionally, set a global error state or display a fallback UI
    });
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
